/*
 * List of possible screen sizes.
 *
 * @var {object}
 */
export const screenSizes = {
  MOBILE: '359px',
  TABLET: '767px',
  NOTEBOOK: '1023px'
}
